<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση τύπων παραστατικών..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Παραστατικά</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="primary" 
                rounded 
                elevation="2" 
                class="mb-2 px-4 font-weight-bold white--text" 
                v-bind="attrs" 
                v-on="on"
              >
                <v-icon left size="20">mdi-plus</v-icon>
                <span>ΔΗΜΙΟΥΡΓΙΑ</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <h3>Βασικά στοιχεία</h3>
                  <v-row>
                    <v-col cols="12" md="12" sm="6">
                      <v-text-field
                        v-model="editedItem.description"
                        label="Όνομα παραστατικού"
                        v-bind:error-messages="allerrors.description">
                      </v-text-field>

                      <v-text-field
                        v-model="editedItem.abbreviation"
                        label="Συντομογραφια"
                        v-bind:error-messages="allerrors.abbreviation">
                      </v-text-field>

                      <v-select
                        label="Κατηγορία παραστατικού"
                        v-model="editedItem.document_type_column_value"
                        v-bind:items="documentCategories"
                        item-text="name"
                        item-value="type_column_value"
                        v-bind:error-messages="allerrors.document_classification_id">
                      </v-select>


                      <v-select
                        label="Είδος παραστατικού"
                        v-model="editedItem.document_classification_id"
                        v-bind:items="documentClassifications"
                        item-text="description"
                        item-value="id"
                        v-bind:error-messages="allerrors.document_classification_id">
                      </v-select>

                      <v-text-field
                        v-model="editedItem.logariasmos_logistikis"
                        label="Λογαριασμός λογιστικής"
                        v-bind:error-messages="allerrors.logariasmos_logistikis">
                      </v-text-field>

                      <h3>Σειρές παραστατικού</h3>

                      <v-data-table
                        hide-default-footer
                        disable-pagination
                        disable-filtering
                        :headers="seriesHeaders"
                        :items="editedItem.series">


                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon small class="mr-2" @click="editSeriesItem(item)"> mdi-pencil </v-icon>
                          <v-icon small color="danger" @click="deleteSeriesItem(item)"> mdi-delete </v-icon>
                        </template>
                      </v-data-table>


                      <h3>Χρεώσεις παραστατικού</h3>
                      <v-list label="Χρεώσεις" shaped>
                        <v-list-item-group
                          v-model="editedItem.linked_charges"
                          multiple>
                          <template v-for="(item, i) in chargeTypes">
                            <v-divider
                              v-if="!item"
                              v-bind:key="`divider-${i}`">
                            </v-divider>

                            <v-list-item
                              v-else
                              v-bind:key="`item-${i}`"
                              v-bind:value="item.id"
                              active-class="deep-purple--text text--accent-4">
                              <template v-slot:default="{ active }">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.description"></v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-checkbox
                                    v-bind:input-value="active"
                                    color="deep-purple accent-4"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </template>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.description }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      loading: true,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Περιγραφή',
          align: 'start',
          //sortable: false,
          value: 'description',
        },
        {
          text: 'Κατηγορία παραστατικού',
          value: 'category'
        },
        { 
          text: 'Είδος παραστατικού', 
          value: 'classification.description' 
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],


      seriesHeaders: [
        {
          text: 'Όνομα',
          value: 'name'
        },
        {
          text: 'Αυτόματη αρίθμηση',
          value: 'autonumbered'
        },
        { 
          text: 'Actions', 
          value: 'actions', 
          sortable: false 
        },
      ],

      documentCategories: [],
      documentClassifications: [],
      documentTypes: [],
      chargeTypes: [],

      allerrors: {},
      editedIndex: -1,
      editedItem: {
        description: '',
        abbreviation: '',
        logariasmos_logistikis: '',
        document_classification_id: '',
        linked_charges: []
        
      },
      defaultItem: {
        description: '',
        abbreviation: '',
        logariasmos_logistikis: '',
        document_classification_id: '',
        linked_charges: []
      },



      seriesDialog: false,
      seriesDialogDelete: false,
      editedSeriesIndex: -1,
      editedSeriesItem: {
        name: '',
        autonumbered: '',
        
      },
      defaultSeriesItem: {
        name: '',
        autonumbered: true
      },





    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      seriesDialog (val) {
        val || this.seriesClose()
      },
      seriesDialogDelete (val) {
        val || this.seriesCloseDelete()
      },

    },

    created () {
      this.initialize()
    },

    methods: {

      mixmatch(documentType) {
        // console.log('mixmatching:')
        // console.log(documentType)
        
        documentType.classification = this.documentClassifications.find(classification => classification.id == documentType.document_classification_id)

        return documentType
      },

      initialize () {
        this.loading = true;
        
        axios.all([
          axios.get('/api/document-types/categories'),
          axios.get('/api/tax-authority/document-classifications'),
          axios.get('/api/charge-types'),
          axios.get('/api/document-types/')
        ])
        .then(axios.spread(
          (
            documentCategoriesResponse, 
            documentClassificationsResponse, 
            chargeTypesResponse, 
            documentTypesResponse
          ) => {
            this.documentCategories = documentCategoriesResponse.data
            this.documentClassifications = documentClassificationsResponse.data.sort((a, b) => a.description.localeCompare(b.description))
            this.chargeTypes = chargeTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
            this.documentTypes = documentTypesResponse.data
            this.documentTypes.map(documentType => this.mixmatch(documentType))

            this.items = this.documentTypes

          })
        ).catch(error => { console.log(error) }).finally(() => { this.loading = false; })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.document_classification_id = item.classification.id
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios.delete(`/api/document-types/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },




      editSeriesItem (item) {
        this.editedSeriesIndex = this.editedItem.series.indexOf(item)
        this.editedSeriesItem = Object.assign({}, item)
        this.seriesDialog = true
      },

      deleteSeriesItem (item) {
        this.editedSeriesIndex = this.editedItem.series.indexOf(item)
        this.editedSeriesItem = Object.assign({}, item)
        this.seriesDialogDelete = true
      },

      deleteSeriesItemConfirm () {
        // axios.delete(`/api/document-types/${this.items[this.editedIndex].id}`)
        // .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        // .catch(error => console.log(error))
      },

      closeSeries () {
        this.seriesDialog = false
        this.$nextTick(() => {
          this.editedSeriesItem = Object.assign({}, this.defaultSeriesItem)
          this.editedSeriesIndex = -1
        })
      },

      closeSeriesDelete () {
        this.seriesDialogDelete = false
        this.$nextTick(() => {
          this.editedseriesItem = Object.assign({}, this.defaultSeriesItem)
          this.editedSeriesIndex = -1
        })
      },









      save () {
        let requestBody = {
          description: this.editedItem.description, 
          abbreviation: this.editedItem.abbreviation ?? null,
          logariasmos_logistikis: this.editedItem.logariasmos_logistikis ?? null,
          document_classification_id: this.editedItem.document_classification_id,
          linked_charges: this.editedItem.linked_charges
        }

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/document-types/${this.editedItem.id}`, requestBody)
          .then(response => { Object.assign(this.items[this.editedIndex], this.mixmatch(response.data)); this.close(); })
          .catch(error => { console.log(error) })
          
        } else {

          axios.post('/api/document-types', requestBody)
          .then(response => { 
            this.items.push(this.mixmatch(response.data)); 
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            this.allerrors = {}
            this.close();
          })
          .catch(error => {
            console.log(error)

            if (error.response.data)
              this.allerrors = error.response.data.errors

          })
        }
      },
    },
  }
</script>

<style scoped>
</style>